import { Card, Container, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Calendar } from "../../calendar/Calendar";
import FarmerActivity from "./FarmerActivity";

const useStyle = makeStyles(() => ({
  announcementCard: {
    margin: "10px",
    background: "#F2F2F2",
  },
  absentCard: {
    width:"100%",
    background: "#F2F2F2",
    margin: "10px",
    padding: "5px"
  },
  calendarCard: {
    margin: "10px",
    background: "#F2F2F2",
    paddingBottom: "20px"
  },
}));

export default function Dashboard() {
  const styles = useStyle();
  return (
    <Container>
      <Card className={styles.announcementCard}>Announcement</Card>
      <Box display={"flex"}>
        <Card className={styles.absentCard}>
          <FarmerActivity title={"Petani Beraktifitas"} dashboard={'dashboard'}/>
        </Card>
        <Card className={styles.absentCard}>
          <FarmerActivity title={"Petani Tidak Beraktifitas"} dashboard={'dashboardNo'}/>
        </Card>
      </Box>
      <Card className={styles.calendarCard}>
        <Calendar/>
      </Card>
    </Container>
  );
}
